import { Component, Input, AfterViewInit, OnInit } from '@angular/core';

import { ExpanderDirective } from '../../directives/expander.directive';
import { IResearchStudyDisplay } from '../../interfaces';

@Component({
  selector: 'lib-trial-details',
  templateUrl: './trial-details.component.html'
})
export class TrialDetailsComponent extends ExpanderDirective implements AfterViewInit, OnInit {

  @Input()
  selectedResearchStudy: IResearchStudyDisplay;

  ngOnInit(): void {
    if (this.selectedResearchStudy) {
      this.expanderSelector = `#trialDetailsCollapse-${ this.selectedResearchStudy.researchStudy.id }`;
    }
  }

  openLink(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
